import { FixedSizeList as List } from "react-window";
import { Card, PostMiniCardBase } from "./post-mini-card";
import { useRef, useEffect } from "react";

// Card height calculation: PostMiniCardBase height (55px) + gap-[8px] spacing
// WARNING: If PostMiniCardBase styling changes, this constant must be updated
const CARD_HEIGHT = 63;

// Container height based on typical modal viewport
// TODO: Consider making this responsive based on viewport height or measuring container dynamically
const DEFAULT_CONTAINER_HEIGHT = 600;

interface VirtualizedMiniCardListProps {
  cards: Card[];
  onSelect: (card: Card) => void;
  onClose: (card: Card) => void;
  onDuplicate?: (card: Card) => void;
  isReachedMaxFormCount: boolean;
  selectedCardIndex: number;
  containerHeight?: number; // Optional: override default container height
}

export const VirtualizedMiniCardList = ({
  cards,
  onSelect,
  onClose,
  onDuplicate,
  isReachedMaxFormCount,
  selectedCardIndex,
  containerHeight = DEFAULT_CONTAINER_HEIGHT,
}: VirtualizedMiniCardListProps) => {
  const listRef = useRef<List>(null);

  // Scroll to selected card when it changes
  useEffect(() => {
    if (selectedCardIndex >= 0 && listRef.current) {
      listRef.current.scrollToItem(selectedCardIndex, "smart");
    }
  }, [selectedCardIndex]);

  const Row = ({
    index,
    style,
  }: {
    index: number;
    style: React.CSSProperties;
  }) => {
    const card = cards[index];
    return (
      <div style={style} className="px-2">
        <PostMiniCardBase
          card={card}
          onClick={() => onSelect(card)}
          onClose={() => onClose(card)}
          onDuplicate={() => onDuplicate?.(card)}
          showDuplicate={
            card.form?.requestType === "create" && !isReachedMaxFormCount
          }
        />
      </div>
    );
  };

  return (
    <List
      ref={listRef}
      height={containerHeight}
      itemCount={cards.length}
      itemSize={CARD_HEIGHT}
      width="100%"
      className="scrollbar-thin"
    >
      {Row}
    </List>
  );
};
